import * as Yup from 'yup';

export const comaSeparatedZipCodesRegExp = /^\d{5}(?:-\d{4})?(?:,\s*\d{5}(?:-\d{4})?,?)*$/;
export const comaSeparatedDigitsRegExp = /^\d+(\s*,\s*\d+,?)*$/;

export const incsAndExcsFormSchema = Yup.object().shape({
  excludedStates: Yup.array(Yup.string()).nullable(),
  isCurrent: Yup.boolean().nullable(),
  includedZipCodes: Yup.string()
    .matches(comaSeparatedZipCodesRegExp, {
      message: 'Please provide valid zip codes separated by comma',
    })
    .nullable(),
  includedContactIds: Yup.string()
    .matches(comaSeparatedDigitsRegExp, {
      message: 'Please provide valid contact IDs separated by comma',
    })
    .nullable(),
  leadStateZipId: Yup.string().nullable(),
});
